import { render, staticRenderFns } from "./service_agreement.vue?vue&type=template&id=5beb134f&scoped=true"
import script from "./service_agreement.vue?vue&type=script&lang=js"
export * from "./service_agreement.vue?vue&type=script&lang=js"
import style0 from "./service_agreement.vue?vue&type=style&index=0&id=5beb134f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beb134f",
  null
  
)

export default component.exports